export default "__VITE_ASSET__BaF9rlgs__"